export default "__VITE_ASSET__Cnob1omd__"